import {
    SET_ERROR_BAR,
    SET_INFO_BAR,
    SET_WARNING_BAR,
    CLEAR_MESSAGE_BAR
} from '../Actions/messages';

const initialState = {
    error: '',
    warning: '',
    info: '',
    msgType: ''
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_ERROR_BAR:
            return {...state, error: action.error};
        case SET_WARNING_BAR:
            return {...state, warning: action.warning, msgType: action.msgType};
        case SET_INFO_BAR:
            return {...state, info: action.message, msgType: action.msgType};
        case CLEAR_MESSAGE_BAR:
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/Reducers/messages.js